/**
 * For each key-value pair from obj, replace all occurrences of the key with the corresponding value in str.
 * @category Utils
 */
export const replaceAll = (str: string, obj: Record<string, any>) =>
  Object.entries(obj).reduce((acc, [key, value]) => acc.replace(new RegExp(`{${key}}`, 'g'), value), str)
